import React from "react";

export default function Pill({ text, clr }) {
  var bg2 = text.startsWith("++") ? "#FFF8E0" : (clr + "1A");
  var fg = text.startsWith("++") ? "#D69E2E" : clr;
  return <span style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: .5, padding: "3px 8px", borderRadius: 10, whiteSpace: "normal", overflowWrap: "anywhere", maxWidth: "100%", boxSizing: "border-box", display: "inline-block", lineHeight: 1.35, background: bg2, color: fg }}>{text}</span>;
}
